export default {
  brand: 'Pronto Admin',
  brandLogoNegative: '/img/brand/pronto-logo-negative.svg',
  brandLogoPositive: '/img/brand/pronto-logo-positive.svg',
  brandLogoGradient: '/img/brand/pronto-logo-gradient.svg',
  apiUrl: process.env.VUE_APP_API_URL
}
